import { render, staticRenderFns } from "./fulfillment-hold-release.vue?vue&type=template&id=07349f53&"
import script from "./js/fulfillment-hold-release.js?vue&type=script&lang=js&"
export * from "./js/fulfillment-hold-release.js?vue&type=script&lang=js&"
import style0 from "./fulfillment-hold-release.vue?vue&type=style&index=0&id=07349f53&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports